import { visitSteps } from '@/mocks/home';

export default function StepsSection() {
  return (
    <section id="guide" className="scroll-mt-24 bg-secondary-900 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-200 bg-white/10 px-3 py-1.5 rounded-full">
            <i className="ri-route-line"></i>
            访问指南
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-background-50 leading-snug">
            安全访问的五步流程
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-100/85">
            与其在遇到问题时手忙脚乱，不如按固定顺序走一遍。下面五个步骤覆盖了从确认来源到异常处理的全过程，
            养成习惯之后，绝大多数风险都能在点击之前就被拦住。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
          {visitSteps.map((item) => (
            <li
              key={item.step}
              className="relative rounded-lg bg-background-50/5 border border-background-50/15 p-6 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-3xl text-background-50/25">{item.step}</span>
              </div>
              <h3 className="mt-5 font-heading text-lg text-background-50">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100/80">{item.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-8 rounded-lg bg-white/5 border border-background-50/15 p-6 md:p-7">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-5">
            <p className="text-sm md:text-base leading-relaxed text-background-100/85 max-w-2xl">
              <strong className="text-background-50 font-medium">一句话总结：</strong>
              来源不明不点开，页面异常就退出，敏感信息不乱填，拿不准时先回到官方渠道确认。
            </p>
            <a
              href="#security"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              继续看安全提示
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}